export default {
  translation: {
    nav: {
      home: 'होम',
      trips: 'यात्राएं',
      aboutUs: 'हमारे बारे में',
      alerts: 'सूचनाएं',
      wishlist: 'इच्छा-सूची',
      language: 'भाषा',
      profile: 'प्रोफ़ाइल',
      settings: 'सेटिंग्स',
      signIn: 'लॉग इन',
      signUp: 'साइन अप'
    },
    hero: {
      title: 'युगांडा की खोज करें',
      subtitle: 'और आगे',
      description: 'विशेषज्ञ स्थानीय गाइडों के साथ अफ्रीका के मोती की खोज करें। युगांडा के मनमोहक परिदृश्य और जीवंत संस्कृति में यादगार अनुभव आपका इंतजार कर रहे हैं।',
      searchPlaceholder: 'आप कहाँ जाना चाहते हैं?',
      categories: {
        all: 'सभी',
        wildlife: 'वन्यजीवन',
        safari: 'सफारी',
        cultural: 'सांस्कृतिक',
        adventure: 'साहसिक',
        birding: 'पक्षी दर्शन'
      }
    },
    common: {
      from: 'से',
      reviews: 'समीक्षाएं',
      viewMore: 'और देखें',
      book: 'बुक करें',
      seeAll: 'सभी देखें',
      loading: 'लोड हो रहा है...'
    }
  }
};